<template>
  <common-page-table
    :titleTable="$t('Бренды')"
    :apiName="apiName"
    :nameRole="nameRoleEntity"
    :paramsGetData="paramsGetData"
    :fieldLand="fieldLang"
    :hasLang="false"
    :keyTable="'id'"
    :alternativeConverter="convertData"
    :isDefaultConverter="false"
    :deleteParams="deleteParams"
    :apiDeleteName="apiDeleteName"

    :forceIsCreate="false"
    :forceIsEdit="false"
    :forceDelete="false"
  />
</template>
<script>
import { NAME_OBJECT, LIST_EQUIVALENT } from "../../../../RoleConstanans";
import CommonPageTable from "../../commonElement/CommonPageTable.vue";
import { API_METHODS, FIELD_LANG_COMPANY } from "../../../../constant";
import convertLangDataToTable from "../../../../helpers/converters/convertLangDataToTable";
import formatData from "../../../../helpers/converters/formatData";
export default {
  name: "TablePagePerson",
  components: { CommonPageTable },
  data() {
    return {
      fieldLang: FIELD_LANG_COMPANY,
      apiName: API_METHODS.GET_ALL_COMPANY,
      apiDeleteName: API_METHODS.DELETE_COMPANY
    };
  },
  computed: {
    paramsGetData() {
      return { typeCompany: 'Brand' };
    },
    nameRoleEntity() {
      return NAME_OBJECT.brand;
    }
  },
  methods: {
    convertData(dataNow, langNow) {
      let res = convertLangDataToTable(dataNow, langNow, FIELD_LANG_COMPANY)
      return res;
    },
    deleteParams(id) {
      return { id: id };
    }
  }
};
</script>

